import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

/*
@filters: all filters on this dash
{
    1: {
      "id": 1,
      "filterConfig": { "column": "Student_Id", "value": "2748141" },
      "widgetIds": [1, 2, 3]
    },
    2: {
      "id": 2,
      "filterConfig": { "column": "Student_Id", "value": "2748141" },
      "widgetIds": [1, 2, 3]
    },
  ...
}
@activeFilters: filters that active on widgets
{
    1: {
      "id": 1,
      "filterConfig": { "column": "Student_Id", "value": "2748141" },
      "widgetIds": [1, 2, 3]
    },
    2: {
      "id": 2,
      "filterConfig": { "column": "Student_Id", "value": "2748141" },
      "widgetIds": [1, 2, 3]
    },
  ...
}
 @crossFilter: filter that used for crossing filtering when click on Chart
{
    colName: [value]
}
@filtersInActiveView: Holds filter changes before they are applied
{
    1: {
      "id": 1,
      "filterConfig": { "column": "Student_Id", "value": "2748141" },
      "widgetIds": [1, 2, 3]
    },
    2: {
      "id": 2,
      "filterConfig": { "column": "Student_Id", "value": "2748141" },
      "widgetIds": [1, 2, 3]
    },
  ...
}  */

const dashboardViewsFiltersInit = {
  views: [],
  filters: {},
  activeFilters: {},
  crossFilter: {},
  filtersInActiveView: {}, // Holds filter changes before they are applied
  activeViewId: null,
  viewSaveEnalbed: { enabled: false, buttonText: "Save" },
  filterIdAssignToWidgets: null,
  idsForInvalidFilters: [],
  maxFilterLimit: 15,
};

function dashboardViewsFiltersReducer(draft, { type, payload }) {
  switch (type) {
    case "setViews": {
      draft.views = payload;
      break;
    }
    case "setActiveFilters": {
      //first check if crossFilter contains anything, if yes, set it as {}
      if (Object.keys(draft.crossFilter).length > 0) {
        draft.crossFilter = {};
      }
      draft.activeFilters = payload;
      break;
    }
    case "setCrossFilter": {
      const key = Object.keys(payload)[0];
      if (draft.crossFilter[key]) {
        //delete it
        delete draft.crossFilter[key];
      } else {
        draft.crossFilter = payload
      }
      break;
    }
    case "setFiltersInActiveView": {
      draft.filtersInActiveView = payload;
      break;
    }
    case "addFilterToFiltersInActiveView": {
      draft.filtersInActiveView[payload.filterId] = payload.filterData;
      break;
    }
    case "updateFiltersInActiveViewConfig": {
      draft.filtersInActiveView[payload.id].filterConfig =
        payload.newFilterConfig;
      break;
    }
    case "updateFiltersInActiveViewWidgetIds": {
      draft.filtersInActiveView[payload.id].widgetIds = payload.widgetIds;
      break;
    }
    case "setFilters": {
      draft.filters = payload;
      break;
    }
    case "setIdsForInvalidFilters": {
      draft.idsForInvalidFilters = payload;
      break;
    }
    case "setActiveViewId": {
      draft.activeViewId = payload;
      break;
    }
    case "setFilterIdAssignToWidgets": {
      draft.filterIdAssignToWidgets = payload;
      break;
    }
    case "setViewSaveEnalbed": {
      draft.viewSaveEnalbed = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [DashboardViewsFiltersContext, DashboardViewsFiltersDispatch] = [
  createContext(null),
  createContext(null),
];

export default function DashboardViewsFiltersProvider({ children }) {
  const [dashboardViewsFiltersStore, dispatch] = useImmerReducer(
    dashboardViewsFiltersReducer,
    dashboardViewsFiltersInit
  );

  return (
    <DashboardViewsFiltersContext.Provider value={dashboardViewsFiltersStore}>
      <DashboardViewsFiltersDispatch.Provider value={dispatch}>
        {children}
      </DashboardViewsFiltersDispatch.Provider>
    </DashboardViewsFiltersContext.Provider>
  );
}

export function useDashboardViewsFiltersStore() {
  return useContext(DashboardViewsFiltersContext);
}

export function useDashboardViewsFiltersDispatch() {
  return useContext(DashboardViewsFiltersDispatch);
}
